import React, {useEffect, useState} from 'react'
import TitreRapport from './titre_rapport.js'
import GraphAleasRapport from './graphAleas_Rapport.js'
import GraphAleasNBjoursRapport from './graphAleasNbjours_Rapport.js'
import GraphAleasNBjoursRapport2 from './graphAleasNbjours_Rapport2.js'
import apiLink from '../../config.js'
import FooterPDF from './footer.js'

function PageAleasPDF({idExploit}) {
  const [ExploitMixte, setExploitMixte] = useState(false)
  const [ExploitViti, setExploitViti] = useState(false)
  const [ExploitGC,setExploitGC] = useState(true)

  const [dataMoy_SH_2D, setDataMoy_SH_2D] =  React.useState()
  const [dataMoy_SH_4D, setDataMoy_SH_4D] =  React.useState()
  const [dataMin_SH_2D, setDataMin_SH_2D] =  React.useState()
  const [dataMin_SH_4D, setDataMin_SH_4D] =  React.useState()
  const [dataMax_SH_2D, setDataMax_SH_2D] =  React.useState()
  const [dataMax_SH_4D, setDataMax_SH_4D] =  React.useState()
  const [dataQ1_SH_2D, setDataQ1_SH_2D] =  React.useState()
  const [dataQ1_SH_4D, setDataQ1_SH_4D] =  React.useState()
  const [dataQ3_SH_2D, setDataQ3_SH_2D] =  React.useState()
  const [dataQ3_SH_4D, setDataQ3_SH_4D] =  React.useState()
  const [dataNbjours_SH_2D, setdataNbjours_SH_2D] = React.useState()
  const [dataNbjours_SH_4D, setdataNbjours_SH_4D] = React.useState()
  const [dataNbjours_SH_Max_2D, setNBJ_SH_MAX_2D] = React.useState()
  const [dataNbjours_SH_Max_4D, setNBJ_SH_MAX_4D] = React.useState()
  const [dataNbjours_SH_Min_2D, setNBJ_SH_MIN_2D] = React.useState()
  const [dataNbjours_SH_Min_4D, setNBJ_SH_MIN_4D] = React.useState()


  function fetchData() {
    fetch(apiLink + 'page/production-rapport/' + idExploit)
    .then( (response) => {
    return response.json()
    })
    .then(response =>{
    let data = response
    for (var cle in data) {
        if (cle.includes("Vignes")) {
            setExploitMixte(true)
            setExploitGC(false)
            setExploitViti(false);
            break;
        }
    }
    let allKeysContainVignes = Object.keys(data).every(cle => cle.includes("Vignes"));
    if (allKeysContainVignes) {
        setExploitViti(true);
        setExploitMixte(false)
        setExploitGC(false)
    } else {
        setExploitViti(false);
    }
    })

    fetch('https://api2050.diagorisk.com/pageAleas/?idExploitation=' + idExploit + '&idProduction=none')
      .then((response) => response.json())
      .then((response) => {
        if ('error' in response) {
          // Si la réponse contient une erreur, relancer la requête après 60 secondes
          setTimeout(fetchData, 60000);
        } else {
          // Si la réponse est réussie, mettre à jour les données
          setDataMoy_SH_2D(response.dataMoy_SH_2D)
          setDataMoy_SH_2D(prev => {
            return prev;
          })
          setDataMoy_SH_4D(response.dataMoy_SH_4D)
          setDataMoy_SH_4D(prev => {
            return prev;
          })
          setDataMin_SH_2D(response.dataMin_SH_2D)
          setDataMin_SH_2D(prev => {
            return prev;
          })
          setDataMin_SH_4D(response.dataMin_SH_4D)
          setDataMin_SH_4D(prev => {
            return prev;
          })
          setDataMax_SH_2D(response.dataMax_SH_2D)
          setDataMax_SH_2D(prev => {
            return prev;
          })
          setDataMax_SH_4D(response.dataMax_SH_4D)
          setDataMax_SH_4D(prev => {
            return prev;
          })
          setDataQ1_SH_2D(response.dataQ1_SH_2D)
          setDataQ1_SH_2D(prev => {
            return prev;
          })
          setDataQ1_SH_4D(response.dataQ1_SH_4D)
          setDataQ1_SH_4D(prev => {
            return prev;
          })
          setDataQ3_SH_2D(response.dataQ3_SH_2D)
          setDataQ3_SH_2D(prev => {
            return prev;
          })
          setDataQ3_SH_4D(response.dataQ3_SH_4D)
          setDataQ3_SH_4D(prev => {
            return prev;
          })
          setdataNbjours_SH_2D(response.dataNbjours_SH_2D)
          setdataNbjours_SH_2D(prev => {
            return prev;
          })
          setdataNbjours_SH_4D(response.dataNbjours_SH_4D)
          setdataNbjours_SH_4D(prev => {
            return prev;
          })
          setNBJ_SH_MAX_2D(response.dataNbjoursMax_SH_2D)
          setNBJ_SH_MAX_2D(prev => {
            return prev;
          })
          setNBJ_SH_MAX_4D(response.dataNbjoursMax_SH_4D)
          setNBJ_SH_MAX_4D(prev => {
            return prev;
          })
          setNBJ_SH_MIN_2D(response.dataNbjoursMin_SH_2D)
          setNBJ_SH_MIN_2D(prev => {
            return prev;
          })
          setNBJ_SH_MIN_4D(response.dataNbjoursMin_SH_4D)
          setNBJ_SH_MIN_4D(prev => {
            return prev;
          })
        }
      })
      .catch((error) => {
        // Gérer les erreurs de la requête
        console.error('Erreur lors de la requête API :', error);
      });
  }
  useEffect ( () => {
    fetchData()
  }, [idExploit])
  
  return (
    <div className='containerPrint'>
      <TitreRapport Titre={'Impact du Stress hydrique'} Sous_Titre={"Sur toute l'exploitation"} Page={ExploitViti ? '0' : '5'}/>
      <div className='paragraphe'>Pour chaque aléa, nous comparons les impacts maximums, moyens et minimums pour toutes les cultures de l'exploitation et pour une scénario à +2°C ou +4°C.</div>
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Niveau des risques de 2020 à 2050 </div>
      <div className='row' style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_SH_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_SH_2D} myDataMax4D={dataMax_SH_4D} aleas={'SH'} print={true} dataType={"Val"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_SH_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_SH_2D} myDataMoy4D={dataMoy_SH_4D}  aleas={'SH'} print={true} dataType={"Val"} type={'Moy'}/> :""}
        </div>
      </div>
      
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Evolution entre 2020 et 2050</div>
      <div className='row'  style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_SH_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_SH_2D} myDataMax4D={dataMax_SH_4D} aleas={'SH'} print={true} dataType={"Diff"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_SH_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_SH_2D} myDataMoy4D={dataMoy_SH_4D}  aleas={'SH'} print={true} dataType={"Diff"} type={'Moy'}/> :""}
        </div>
      </div>
      <FooterPDF idExploit={idExploit} top={'-20px'} />
    </div>
  )
}

export default PageAleasPDF